import { useState, useEffect } from 'react';
import moment from 'moment';
import { ReactComponent as DefaultFormPic } from '@Assets/form.svg';
import { ReactComponent as OrganizationIcon } from '@Assets/organization.svg';
import { ReactComponent as ProjectIcon } from '@Assets/project.svg';
import { useNavigateWithRedirect } from '@Hooks/useNavigateWithRedirect';
import { useRecentlyVisited } from '@Hooks/useRecentlyVisited';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import '@Partials/_ComStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './SearchFormRow.scss'

export default function SearchFormRow(props) {

    const navigate = useNavigateWithRedirect();
    const { addRecentForm } = useRecentlyVisited();
    const [kaiziqResolveConnection, setKaiziqResolveConnection] = useState({});
    const className = 'searchFormRow';

    useEffect(() => {
        setKaiziqResolveConnection(props.kaiziqResolveConnection)
    }, [props])

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    };

    const handleRowClick = () => {
        addRecentForm({
            formId:      kaiziqResolveConnection.formId,
            title:       kaiziqResolveConnection.title,
            orgName:     kaiziqResolveConnection.orgName,
            projectName: kaiziqResolveConnection.projectName,
        });
        navigate('/report/' + kaiziqResolveConnection.formId);
//        setSearchParams({type: 'form', subType: 'report', 'formId': kaiziqResolveConnection.formId});
//        localStorage.setItem('view', JSON.stringify({ type: 'form', subType: 'report', formId: kaiziqResolveConnection.formId}));
//        window.dispatchEvent(new Event('storage'));
    }

    return (
        <div className={className} onClick={handleRowClick}>
            <div className={className + '__inner flex-column-flex-start'}>
                <div className={className + '__inner__top flex-row-center-0p5rem-gap width-wfa'}>
                    <div className={className + '__inner__top__pic flex-row-center-1vw-gap'}>
                        {
                            !!kaiziqResolveConnection?.photo ?
                            <img
                                src={URL.createObjectURL(dataURLtoFile(kaiziqResolveConnection?.photo))}
                                className={className + '__inner__top__pic__photo'}
                                alt='Form Description'/> :
                            <DefaultFormPic className={className + '__inner__top__pic__photo opacity-0p6'}/>
                        }
                    </div>
                    <Tooltip title={kaiziqResolveConnection?.formId} slots={{ transition: Zoom }} placement="bottom-start" arrow>
                        <div className={className + '__inner__top__tag semi-large-text bold-text blue-text'}>
                            {kaiziqResolveConnection?.formId}
                        </div>
                    </Tooltip>
                </div>
                <div className={className + '__inner__details flex-column-flex-start-1vh-gap width-wfa'}>
                    <div className={className + '__inner__details__title'}>
                        {kaiziqResolveConnection?.title}
                    </div>
                    <div className={className + '__inner__details__project flex-row-center-0p5rem-gap'}>
                        <ProjectIcon className={className + '__inner__details__project__icon standard-icon '}/>
                        <div className={className + '__inner__details__project__name semi-bold-text'}>
                            {kaiziqResolveConnection?.projectName}
                        </div>
                    </div>
                    <div className={className + '__inner__details__org flex-row-center-0p5rem-gap'}>
                        <OrganizationIcon className={className + '__inner__details__org__icon standard-icon'}/>
                        <div className={className + '__inner__details__org__name semi-bold-text'}>
                            {kaiziqResolveConnection?.orgName}
                        </div>
                    </div>
                    <div className={className + '__inner__details__createTimeStamp flex-row-center sm-text grey-text'}>
                        <div className={className + '__inner__details__createTimeStamp__t1'}>
                            Created &nbsp;
                        </div>
                        <div className={className + '__inner__details__createTimeStamp__t2 semi-bold-text'}>
                             {moment(new Date(kaiziqResolveConnection?.createTimeStamp),'DD-MM-YYYY').fromNow()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
